exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body {\n  font-family: \"Segoe UI\", \"Segoe UI Web (West European)\", \"Segoe UI\", -apple-system, BlinkMacSystemFont, Roboto, \"Helvetica Neue\", sans-serif;\n  -webkit-font-smoothing: antialiased;\n  margin: 8px;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto; }\n\n#container {\n  height: 100%;\n  overflow-x: visible;\n  overflow-y: visible; }\n\n.ms-CommandBar {\n  margin: -8px -8px 8px -8px; }\n", ""]);

// exports
